export const ExclusiveTreesIcon = () => (
  <svg
    width={46}
    height={46}
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_599_17678)">
      <path
        d="M32.18 41.89C31.85 41.89 31.52 41.8701 31.19 41.8401L15.6399 40.1301C12.9299 39.8301 10.5399 38.33 9.07992 36.11C6.65992 34.5101 5.16992 31.81 5.16992 28.8301V13C5.16992 8.19003 9.07992 4.28003 13.8799 4.28003H29.7199C33.39 4.28003 36.5399 6.56003 37.8199 9.78003C41.1299 11.42 43.1999 14.98 42.7799 18.82L41.1299 33.87C40.6299 38.4501 36.78 41.9001 32.18 41.9001V41.89Z"
        fill="url(#paint0_linear_599_17678)"
      />
      <path
        d="M29.7776 8.26465H13.8118C11.2395 8.26465 9.1543 10.3499 9.1543 12.9221V28.888C9.1543 31.4602 11.2395 33.5455 13.8118 33.5455H29.7776C32.3499 33.5455 34.4351 31.4602 34.4351 28.888V12.9221C34.4351 10.3499 32.3499 8.26465 29.7776 8.26465Z"
        fill="url(#paint1_linear_599_17678)"
      />
      <path
        d="M33.9793 12.4387L19.3303 10.8111C16.2635 10.4703 13.5011 12.6802 13.1604 15.747L11.5328 30.396C11.192 33.4628 13.4019 36.2252 16.4687 36.5659L31.1177 38.1935C34.1845 38.5343 36.9469 36.3244 37.2876 33.2576L38.9152 18.6086C39.256 15.5418 37.0461 12.7794 33.9793 12.4387Z"
        fill="url(#paint2_linear_599_17678)"
      />
      <path
        opacity={0.62}
        d="M31.2294 21.3602C30.3193 21.2602 29.6494 20.4503 29.7194 19.5402C28.8493 19.4303 28.2193 18.6402 28.3093 17.7602C28.3994 16.8802 29.1894 16.2402 30.0694 16.3202C30.1994 15.4302 31.0193 14.7902 31.9393 14.8902C32.8593 14.9902 33.5093 15.7902 33.4393 16.6902C34.3194 16.8002 34.9493 17.6002 34.8593 18.4803C34.7694 19.3602 33.9693 19.9903 33.0893 19.9102C32.9594 20.8103 32.1394 21.4502 31.2294 21.3502V21.3602Z"
        fill="url(#paint3_linear_599_17678)"
      />
      <path
        d="M30.7209 19.6001L30.8208 18.6602L29.8609 18.5501C29.5208 18.5101 29.2709 18.2102 29.3108 17.8701C29.3508 17.5301 29.6608 17.2802 30.0008 17.3202L30.9608 17.4301L31.0608 16.4901C31.1008 16.1101 31.4409 15.8402 31.8308 15.8801C32.2208 15.9201 32.4808 16.2601 32.4408 16.6401L32.3408 17.5802L33.3109 17.6901C33.6508 17.7301 33.9009 18.0402 33.8608 18.3801C33.8208 18.7201 33.5109 18.9602 33.1708 18.9201L32.2008 18.8101L32.1009 19.7502C32.0608 20.1201 31.7208 20.4001 31.3409 20.3601C30.9608 20.3201 30.6808 19.9701 30.7209 19.6001Z"
        fill="white"
      />
      <path
        opacity={0.62}
        d="M22.1554 32.6124C21.3869 32.5265 20.8367 31.8481 20.9154 31.0924L21.0463 29.9332L19.684 29.7872C18.9854 29.7099 18.3828 29.2633 18.1209 28.6194C17.8589 27.9753 17.9811 27.2454 18.4265 26.713L20.2516 24.5662C20.1469 24.446 20.0595 24.3 19.9984 24.1454C19.7888 23.6216 19.8936 23.0377 20.2604 22.6084L23.7971 18.4436C24.1201 18.0486 24.6354 17.851 25.1506 17.9026C25.6658 17.9541 26.1199 18.2633 26.3557 18.7184L28.8969 23.5444C29.1589 24.0424 29.124 24.6349 28.8008 25.0986C28.7048 25.236 28.5913 25.3477 28.469 25.4421L29.7701 27.9238C30.0932 28.5421 30.0496 29.272 29.6479 29.8473C29.2462 30.4226 28.565 30.7232 27.8665 30.6545L26.5041 30.5086L26.3732 31.6678C26.2859 32.4234 25.596 32.9645 24.8275 32.8872L22.1466 32.5952L22.1554 32.6124Z"
        fill="url(#paint4_linear_599_17678)"
      />
      <path
        d="M28.8761 28.2714L27.1038 24.8871L27.3765 24.9122C27.8962 24.9711 28.2712 24.4336 28.0241 23.9717L25.5444 19.2437C25.3314 18.8322 24.7605 18.7734 24.4623 19.1261L21.0028 23.2075C20.6619 23.6022 20.9091 24.2068 21.4288 24.2656L21.693 24.2908L19.2218 27.2133C18.7021 27.8263 19.0856 28.7501 19.8865 28.8425L22.0594 29.0776L21.8378 31.0511C21.8038 31.3282 22.0082 31.5802 22.2894 31.6054L24.9053 31.8909C25.1865 31.9245 25.4422 31.7229 25.4678 31.4458L25.6893 29.4723L27.8621 29.7074C28.6631 29.7914 29.2425 28.9684 28.8676 28.263L28.8761 28.2714Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_599_17678"
        x1={17.62}
        y1={43.6801}
        x2={28.0899}
        y2={4.61003}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00FF00" />
        <stop offset={0.52} stopColor="#00FF00" stopOpacity={0.89} />
        <stop offset={1} stopColor="#99FF00" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_599_17678"
        x1={20.4521}
        y1={32.4719}
        x2={26.6813}
        y2={-7.77808}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#035219" />
        <stop offset={1} stopColor="#00A40F" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_599_17678"
        x1={30.7597}
        y1={10.6789}
        x2={18.7805}
        y2={38.4705}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00D800" />
        <stop offset={1} stopColor="#027202" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_599_17678"
        x1={33.766}
        y1={16.3794}
        x2={29.3966}
        y2={19.8824}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D1FD00" stopOpacity={0.8} />
        <stop offset={1} stopColor="#DEFD92" stopOpacity={0.5} />
      </linearGradient>
      <linearGradient
        id="paint4_linear_599_17678"
        x1={29.2403}
        y1={22.2127}
        x2={19.3611}
        y2={30.2672}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D1FD00" stopOpacity={0.8} />
        <stop offset={1} stopColor="#DEFD92" stopOpacity={0.5} />
      </linearGradient>
      <clipPath id="clip0_599_17678">
        <rect width={46} height={46} fill="white" />
      </clipPath>
    </defs>
  </svg>
)
